import React, { useEffect } from "react";
import classes from "./UnderMaintanance.scss";
import { ToddleIcon } from "SvgComponents";
import moment from "moment";
import { Button } from "@toddle-edu/ds-web";
import { ReloadArrowOutlined } from "@toddle-edu/ds-icons";
import { setupIntercom } from "Login/modules/LoginModule/LoginUtils";

const UnderMaintenance = React.memo(
  ({ underMaintenance: { endTime = null } = {} }) => {
    useEffect(() => {
      setupIntercom();
    }, []);

    const reloadPage = () => {
      location.reload();
    };

    return (
      <div className={classes.modalContent}>
        <ToddleIcon width={120} height={120} />
        <div
          className={classes.headerText}
        >{`We are undertaking a scheduled maintenance`}</div>
        <div className={classes.text}>{`We'll be back at ${moment(
          endTime
        ).format("hh:mm a")}.`}</div>
        <Button
          size={"small"}
          icon={<ReloadArrowOutlined />}
          onClick={reloadPage}
        >
          {"Reload"}
        </Button>
      </div>
    );
  }
);

UnderMaintenance.displayName = "UnderMaintenance";

export default UnderMaintenance;
